import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class ModalErrorIcon extends PureComponent {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
  };

  static defaultProps = {
    width: 80,
    height: 80,
    fill: '#e8e8e8',
  };

  render() {
    const { width, height, className, fill } = this.props;

    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 80 80"
        preserveAspectRatio="xMinYMin"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g fill="none" fillRule="evenodd">
          <circle cx="47" cy="35" r="21" fill={fill} />
          <circle
            cx="32"
            cy="32"
            r="19"
            fill="#3F3F3F"
            fillOpacity="0"
            stroke="#000"
            strokeWidth="2"
          />
          <circle
            cx="32"
            cy="32"
            r="23"
            fill="#3F3F3F"
            fillOpacity="0"
            stroke="#000"
            strokeWidth="2"
          />
          <g stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
            <path d="M39.92 24.08L24.08 39.92M39.92 39.92L24.08 24.08" />
          </g>
          <g stroke="#000" strokeWidth="2" transform="rotate(45 -27.577 83.648)">
            <rect width="22" height="8" x="6" y="1" rx="4" />
            <path d="M1 3h5v4H1z" />
          </g>
        </g>
      </svg>
    );
  }
}

export default ModalErrorIcon;
